'use strict';

module.exports = function ( url, config, linkName, links  ) {
    links = links || {};
    linkName = linkName || 'local';

    if ( links[linkName] ) {
        links[linkName].abort();
    }

    links[linkName] = core.backend.request(
        url,
        {
            method: config.method,
            version: 3,
            body: config.body,
            onload: function ( error, response ) {
                if ( response.error ) {
                    error = true;
                }

                config.onload(error, response);
                links[linkName] = null;
            },
            onerror: function ( error ) {
                debug.log(error);
                if ( config.onerror ) {
                    config.onerror(true);
                }
                links[linkName] = null;
            },
            ontimeout: function () {
                debug.log('ontimeout');
                if ( config.onerror ) {
                    config.onerror(true);
                }
                links[linkName] = null;
            }
        }
    );
};
